import { module } from 'angular';

import KformComponentsProvider from '~/components/kform/components/kform-components.provider';
import FormBuilderController from './form-builder.controller';
import FormBuilderConfig from './form-builder.config';
import FormBuilderNodeComponentsComponent from './form-builder-node-components.component';

import './form-builder.scss';

export default module('app.formBuilder', [])
	.provider('KformComponents', KformComponentsProvider)
	.value('dndDragIframeWorkaround', {
		isDragging: false,
	})
	.value('componentClipboard', {
		items: [],
	})
	.config(FormBuilderConfig)
	.controller('FormBuilderController', FormBuilderController)
	.component('formBuilderNodeComponents', FormBuilderNodeComponentsComponent)
	.name;
